import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import get from 'lodash-es/get';
import { Subject } from 'rxjs/Subject';
import { first } from 'rxjs/operators/first';

import { getParams } from '@app/shared/utils/utils.object';
import { ConfigService } from '@app/core/config.service';
import { cachedPath } from '@app/shared/components/syndicated-layout/syndicated-options';
import { SYNDICATED_HEADER_ANIMATIONS } from '@app/shared/components/syndicated-layout/syndicated-header/syndicated-header.animations';
import { WindowRef } from '@app/shared/services/window-ref/window-ref.service';

@Component({
    selector: 'syndicated-header',
    templateUrl: './syndicated-header.component.html',
    styleUrls: ['./syndicated-header.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations: [...SYNDICATED_HEADER_ANIMATIONS]
})
export class SyndicatedHeaderComponent implements OnInit {
    @Input() url: string;
    @Input() path: string;
    @Input() version: number;
    @Input() locale: string;
    @Input() language: string;
    @Input() siteId: string;
    @Input() environment: string;

    syndicatedHeaderUrl: string;
    baseURL: string;
    headerOptions: object;
    syndicatedLayoutOptions: any;
    useCached = false; // @TODO validate if the user is not loggedIn to use cache.
    stateName: string;

    constructor(
        private winRef: WindowRef,
        private configService: ConfigService
    ) {
    }

    ngOnInit() {
        this.syndicatedLayoutOptions = this.configService.getValue('syndicatedLayout');
        this.baseURL = this.syndicatedLayoutOptions.baseURL;
        this.headerOptions = this.syndicatedLayoutOptions.header;
        this.syndicatedHeaderUrl = `${this.baseURL}/header${this.useCached ? cachedPath : '/'}${getParams(this.headerOptions)}`;
        this.stateName = 'loaded';
        // @TODO Remove this hack that prevents language modal to switch page's locale.
        // @see https://jira.nge.wdig.com/browse/PRO-353284
        this.setupSyndicatedToggles();
    }

    headerStateDone(event: AnimationEvent) {
        // We want to make sure that the animation is complete and the style has been set
        // by the animation module. Once that is done we can manually remove the style attr.
        setTimeout(() => {
            event['element'].removeAttribute('style');
        });
    }

    /**
     * Setup toggles needed for Syndicated Navbar.
     * @TODO Remove this hack that prevents language modal to switch page's locale.
     * @see https://jira.nge.wdig.com/browse/PRO-353284 see linked ticket for needed devwork.
     */
    setupSyndicatedToggles() {
        const releaseToggles = [
            // Temporarily commented out for GIT-8343
            // 'disableLocaleCookie',
            // 'disableLanguageSelectionCookie'
        ];

        const winRef = this.winRef.nativeWindow;
        const toggleReady: Subject<boolean> = new Subject();
        // Use interval instead of timeout to prevent Angular stability issues in the main thread.
        const toggleSetupInterval = setInterval(setToggles, 100);
        toggleReady
            .asObservable()
            .pipe(
                first()
            )
            .subscribe(() => {
                clearInterval(toggleSetupInterval);
            });

        function setToggles() {
            if (get(winRef, 'PEP.Config.Toggles.Release', false)) {
                // Temporarily commented out for GIT-8343
                // releaseToggles.forEach(function (toggle) {
                //     winRef.PEP.Config.Toggles.Release[toggle] = true;
                // });
                toggleReady.next(true);
            }
        }
    }
}

